export const authorFirstLetter = (author) => {
	const splitStr = author.split(' ');
	return `${splitStr[0][0]}${splitStr[1][0]}`;
};

